const CapitalizationUtil = {
  convertKeysToCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((v) => this.convertKeysToCamelCase(v));
    } else if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce((acc, key) => {
        const camelCaseKey = this.toCamelCase(key);
        acc[camelCaseKey] = this.convertKeysToCamelCase(obj[key]);
        return acc;
      }, {} as any);
    }
    return obj;
  },

  convertTopLevelKeysToCamelCase(obj: any): any {
    if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce((acc, key) => {
        const camelCaseKey = this.toCamelCase(key);
        acc[camelCaseKey] = obj[key];
        return acc;
      }, {} as any);
    }
    return obj;
  },

  toCamelCase(str: string): string {
    return (
      str.charAt(0).toLowerCase() +
      str.slice(1).replace(/_./g, (match) => match[1].toUpperCase())
    );
  },

  toTitleCase(str: string): string {
    if (!str) return "";

    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },
};

export default CapitalizationUtil;
